var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetupInactive = function SvgSetupInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "setupInactive_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 10.435
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#setupInactive_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#C7C7CC",
    rx: 10.435
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#9A9AA0",
    opacity: 0.2,
    rx: 10.435
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#E0E0E5",
    opacity: 0.15,
    rx: 10.435
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FFF",
    opacity: 0.08,
    rx: 10.435
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.937 32.242c-1.352-1.36-1.368-3.187-.016-4.523 1.055-1.047 2.203-1.336 4.195-2.665l-4.578-4.57c-1.094-1.094-1.094-2.265-.023-3.336l1.039-1.039c1.07-1.07 2.242-1.07 3.343.024l4.68 4.71c-.601-1.601-.281-3.437.969-4.687 1.406-1.414 3.617-1.648 5.398-.61l-.765.766-1.367 1.352c-.211.21-.188.484.039.719l.953.96c.226.227.492.211.703 0l1.367-1.359.758-.765c1.047 1.796.804 4.015-.602 5.421-1.344 1.336-3.367 1.602-5.039.813-.375.375-.71.734-1.031 1.078l3.57 3.57.703.11c.282.039.532.21.696.453L32.56 31.1c.165.243.18.493.016.664l-1.398 1.399c-.172.172-.414.172-.664.008l-2.446-1.657a1.02 1.02 0 0 1-.453-.687l-.11-.703-3.413-3.406c-2.211 2.851-2.375 4.257-3.64 5.539-1.337 1.343-3.157 1.328-4.516-.016m12.086-13.234c-.602-.586-.618-1.32-.04-1.891l1.141-1.148a3.34 3.34 0 0 0-2.851.914c-1.329 1.312-1.274 3.515.117 4.906 1.398 1.383 3.586 1.445 4.906.125.758-.766 1.07-1.828.906-2.883l-1.156 1.164c-.547.555-1.29.54-1.867-.039zm-11.782.664 4.742 4.765c.875-.64 1.883-1.476 3.086-2.61l-4.992-4.991c-.57-.563-1.18-.57-1.734-.008l-1.102 1.11c-.562.57-.57 1.163 0 1.734m4.883 1.507-2.906-2.93a.285.285 0 0 1 0-.405.285.285 0 0 1 .406 0l2.922 2.914c.11.109.11.289-.008.421-.101.102-.305.118-.414 0m-.96.954-2.923-2.907c-.117-.109-.11-.297 0-.422a.32.32 0 0 1 .414 0l2.922 2.922a.285.285 0 0 1 0 .407.29.29 0 0 1-.414 0m5.491.382a6 6 0 0 1-.414-.476c-5.547 5.406-6.664 4.601-8.554 6.484-.86.867-.875 2.032.023 2.946.906.89 2.078.882 2.945.007 1.883-1.875 1.078-2.992 6.485-8.539a5 5 0 0 1-.485-.422m3.102 8.032 1.976 1.492.711-.711-1.492-1.984-.875-.149-3.851-3.844c-.157.172-.297.344-.438.508l3.813 3.813zM18.163 31a.967.967 0 0 1-.96-.969.96.96 0 0 1 .96-.96c.531 0 .969.429.969.96a.974.974 0 0 1-.969.969"
  }))));
};
export default SvgSetupInactive;